import * as React from 'react'

const NotFound = () => {
  const style = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw',
    fontSize: 32,
  }

  return <div style={style}>Not Found</div>
}

export default NotFound
